<template>
        <v-dialog
            v-if="lockDialog"
            v-model="lockDialog"
            persistent
            width="600px"
        >
            <v-form ref="lockForm">
                <v-card>
                    <v-card-title class="primary white--text">
                        <v-icon dark class="mr-2">lock</v-icon>Lock Task
                        <v-spacer></v-spacer>

                        <v-btn icon dark @click="$emit('closeLockDialog')">
                            <v-icon>close</v-icon></v-btn
                        >
                    </v-card-title>

                    <v-card-text class="pb-0">
                        <v-toolbar class="py-2" outlined flat>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-toolbar-title
                                        class="title pr-2"
                                        v-on="on"
                                    >
                                        {{
                                            growthTask
                                                ? growthTask.plant.name
                                                : ""
                                        }}
                                        <div
                                            class="
                                                mt-n1
                                                grey--text
                                                text--darken-1
                                                caption
                                            "
                                            v-if="growthTask"
                                        >
                                            {{
                                                (growthTask
                                                    ? growthTask.growthStartDate
                                                    : "1970-01-01")
                                                    | moment("YYYY-[W]WW")
                                            }}
                                        </div>
                                    </v-toolbar-title>
                                </template>
                                <span>{{
                                    growthTask ? growthTask.plant.name : ""
                                }}</span>
                            </v-tooltip>

                            <v-spacer />
                            <v-icon :color="taskColor" class="mr-1">eco</v-icon>
                            <span :class="taskColor + `--text headline`">{{
                                growthTask ? growthTask.totalInventory : 0
                            }}</span>
                        </v-toolbar>

                        <v-list dense class="mt-5">
                            <!-- customer -->
                            <v-list-item>
                                <v-list-item-content>
                                    <v-autocomplete
                                        v-model="
                                            lockingTaskData.lockedForCustomerNodeId
                                        "
                                        :items="customers.edges || []"
                        
                                        :loading="
                                            isLoading
                                        "
                                        item-value="node.id"
                                        item-text="node.name"
                                        label="Lock for customer*"
                                        class="subtitle-2"
                                        outlined
                                        :rules="[rules.required]"
                                        :disabled="!lockingTaskData.isEditing"
                                    ></v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- comment -->
                            <v-list-item class="align-start">
                                <v-list-item-content>
                                    <v-textarea
                                        v-model="lockingTaskData.lockedComment"
                                        auto-grow
                                        label="Note"
                                        outlined
                                        class="subtitle-2"
                                        :disabled="!lockingTaskData.isEditing"
                                    ></v-textarea>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>

                    <v-card-actions class="mr-5 pb-4">
                        <v-btn
                            v-if="
                                lockingTaskData.isEditing &&
                                    lockingTaskData.isLocked
                            "
                            outlined
                            :disabled="!hasPermission('change_growthtask')"
                            rounded
                            color="error"
                            class="ml-5"
                            :loading="isSaving"
                            @click="$emit('unlockGrowthTask')"
                            >Unlock</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn text rounded @click="$emit('closeLockDialog')"
                            >Cancel</v-btn
                        >
                        <v-btn
                            v-if="!lockingTaskData.isEditing"
                            outlined
                            rounded
                            :disabled="!hasPermission('change_growthtask')"
                            color="primary"
                            @click="
                                lockingTaskData.isEditing = !lockingTaskData.isEditing
                            "
                            >Edit</v-btn
                        >
                        <v-btn
                            v-if="lockingTaskData.isEditing"
                            outlined
                            rounded
                            :disabled="!hasPermission('change_growthtask')"
                            color="primary"
                            :loading="isSaving"
                            @click="validateLockForm"
                            >{{
                                lockingTaskData.isLocked ? "Save" : "Lock"
                            }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";

    export default {
        name : 'Lock',
        props : ["lockDialog", "lockingTaskData", "growthTask", "taskColor", "customers", "rules", "isSaving", "isLoading"],
        data() {
            return {
                
            };
        },
        methods : {
            validateLockForm(){
                this.$emit('validatingForm', this.$refs.lockForm.validate())
            }
        },
        created() {
            this.hasPermission = helper.hasPermission;
        },
    }
</script>